<template>
  <div
    :class="['multiselect-default',
      isNoBorder ? 'select-no-border' : 'border-active',
      {'border-danger bg-danger-outline': state},
      {'multiselect-custom': multiSelectCustom},
      {'horizontal-direction': left}
    ]"
    @keydown.esc="handlePressEsc"
    v-click-outside="onClickOutSide"
  >
    <multiselect
      v-on="$listeners"
      :id="id"
      :options="options"
      :disabled="isDisabled"
      :placeholder="placeholder"
      v-model="_dataModel"
      :custom-label="customLabel"
      :searchable="searchable"
      :show-labels="showLabels"
      :close-on-select="closeOnSelect"
      :allow-empty="allowEmpty"
      :multiple="multiple"
      :selectLabel="selectLabel"
      :deselectLabel="deselectLabel"
      :hideSelected="hideSelected"
      :taggable="taggable"
      :openDirection="openDirection"
      @input="onChange"
      @open="onOpen"
      @close="onClose"
      :style="{cursor: isDisabled ? '' : 'pointer'}"
      :class="{'multiselect--focus': !isDisabled && isFocusSelectField}"
    >
      <template slot="noOptions">
        <slot name="noOptions" >
          <span class="noOption">選択項目がありません。</span>
        </slot>
      </template>
      <template slot="noResult">
        <slot name="noResult">
          <span class="noResult">選択項目がありません。</span>
        </slot>
      </template>
      <template slot="singleLabel" slot-scope="props">
        <slot name="singleLabel" :itemLabel="props"></slot>
      </template>
      <template slot="option" slot-scope="props">
        <slot name="options" :itemOption="props"></slot>
      </template>
    </multiselect>
  </div>
</template>
<script>
export default {
  model: {
    prop: 'dataModel',
    event: 'change'
  },
  props: {
    id: {
      type: String | Number,
      default: ''
    },
    multiSelectCustom: {
      type: Boolean,
      default: false
    },
    left: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array | String | Number,
      default: null
    },
    dataModel: {
      type: Number | String,
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    state: {
      type: Boolean,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    deselectLabel: {
      type: String,
      default: ''
    },
    selectLabel: {
      type: String,
      default: ''
    },
    hideSelected: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    searchable: {
      type: Boolean,
      default: false
    },
    customLabel: {
      type: Function
    },
    showLabels: {
      type: Boolean,
      default: false
    },
    allowEmpty: {
      type: Boolean,
      default: false
    },
    taggable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    },
    isNoBorder: {
      type: Boolean,
      default: false
    },
    openDirection: {
      type: String,
      default: ''
    }
  },
  computed: {
    _dataModel: {
      get() {
        return this.dataModel
      },
      set(value) {
        this.$emit('change', value)
      }
    }
  },
  watch: {
    autofocus(newValue) {
      this.isFocusSelectField = newValue
    }
  },
  data() {
    return {
      isFocusSelectField: this.autofocus,
      isOpen: false
    }
  },
  methods: {
    /**
     * 値が変更された後に発行されます
     * @param {*} data ユーザー変更後の値
     */
    onChange(data) {
      this.$emit('onChange', data)
    },
    /**
     * ドロップダウンが開いている場合、isFocusSelectField フィールドは true に設定されます。
     */
    onOpen() {
      this.isOpen = true
      // フォーカス選択フィールドが false の場合、フォーカスされた要素は失われます
      this.isFocusSelectField = true
      this.$emit('onOpen')
    },
    /**
     * ドロップダウンが閉じられたときに発行されます
     */
    onClose() {
      // クローズ イベントは外部のイベントの前に実行されるため、フラグを更新するためにタイムアウトを遅らせる必要があります。
      setTimeout(() => {
        this.isOpen = false
      }, 120)
      this.isFocusSelectField = true
      this.$emit('onClose')
    },
    /**
     * サイド要素をクリックすると、isFocusSelectField フィールドが false に設定されます
     */
    onClickOutSide() {
      // フォーカス選択フィールドが false の場合、フォーカスされた要素は失われます
      if (!this.isOpen) {
        this.isFocusSelectField = false
      }
    },
    /**
     * ユーザーがキーボードで esc を押したときにイベントを処理し、他のコンポーネントへの伝播を停止します
     * @param {KeyboardEvent} event イベント キーダウン イベント
     */
    handlePressEsc(event) {
      if (!event) {
        return
      }
      event.stopPropagation()
    }
  }
}

</script>

<style lang="scss" scoped>
.multiselect-default {
  /deep/ .multiselect--disabled {
    .multiselect__select {
      background: none !important;
      color: $base_dark;
      &:before {
        top: 57%;
      }
    }
  }
  /deep/ .multiselect__option--highlight {
    background: rgba(78, 102, 166, 0.08) !important;
    color: #252422 !important;
  }
  /deep/ .multiselect__placeholder {
    @include textOverflowEllipsis(true);
    @include responsive-fs(16);
    padding-top: 0px;
  }
  /deep/ .multiselect {
    min-height: 38px;
    box-sizing: border-box;
    border-radius: 0.3rem;
    &__single {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      @include responsive-fs(16);
      line-height: normal;
      margin-bottom: 0;
    }
    &__select {
      -webkit-transform: none;
      transform: none;
      min-height: 100%;
      height: 100%;
      &:before {
        top: 57%;
        border-color: $base_dark transparent transparent;
      }
    }
    &__tags:not(:has(input)) {
      border-color: #ced4da;
      @include responsive-fs(14, true);
      display: flex;
      align-items: center;
      padding-top: 0;
      padding-bottom: 0;
    }
    &__tags {
      border-color: #ced4da;
      @include responsive-fs(14, true);
    }
    &__content-wrapper {
      overflow-x: hidden;
      .multiselect__content {
        width: 100%;
        @include responsive-fs(16)
      }
      .multiselect__option {
        width: 100%;
        overflow: hidden !important;
        white-space: nowrap !important;
        text-overflow: ellipsis !important;
        line-height: normal;
        .noOption {
          width: fit-content;
          white-space: nowrap;
          color: #ADB6BE;
          @include responsive-fs(16);
        }
      }
    }
  }
  &__input {
    @include responsive-fs(16);
  }
}

.multiselect-custom {
  /deep/ .multiselect {
  font-weight: bold;
  &__select {
    &:before {
      top: 57%;
      border-color: $base_dark transparent transparent;
    }
  }
  &--active, &--focus {
      border-color: #8B9BC4;
      outline: 0;
      border-radius: 5px;
      box-shadow: 0 0 0 2px rgba(78, 102, 166, 0.5);
      .multiselect__tags {
        border-color: #7a8cbb !important;
      }
    }
  &__tags {
    border-color: #ced4da;
    padding-top: 0px;
    padding-left: 0px;
    padding: 5px 40px 5px 5px;
  }
  &__single {
    display: flex;
    align-items: center;
    height: 100%;
    margin-bottom: 0px !important;
    padding-bottom: 0;
    line-height: normal;
    @include responsive-fs(16);
  }
  &--active {
    /deep/ .multiselect__select {
      &:before {
        top: 65%;
      }
    }
  }
  &__content {
    display: block !important;
    padding: 13px 0;
  }
  &__element {
    padding-inline: 0px;
    &:nth-last-child(3) {
      .multiselect__option > div {
        border-bottom: none;
      }
    }
  }
  &__option {
    display: flex;
    align-items: center;
    padding: 0 24px;
    overflow-x: hidden;
  }
  }
}

.select-no-border {
  /deep/ .multiselect {
    &__select {
      -webkit-transform: none;
      transform: none;
      min-height: 100%;
      height: 100%;
      width: fit-content;
      padding: 0;
      &:before {
        top: 57%;
        border-color: $base_dark transparent transparent;
        margin-top: 0px;
      }
    }
    &__single {
      margin: 0;
      font-weight: 400;
      @include responsive-fs(12);
      line-height: normal;
    }
    &__tags, &__tags:not(:has(input)) {
      border: none;
      height: 100%;
      display: block;
      padding-top: 8px;
      min-height: 100%;
      padding-left: 0;
      padding-right: 12px;
    }
    &__content-wrapper {
      border: 1px solid #e8e8e8;
      border-radius: 5px;
      right: 0;
      width: fit-content;
    }
    &__placeholder {
      display: flex !important;
      align-items: center;
      white-space: nowrap;
      color: #35495e;
      font-weight: 400;
      @include responsive-fs(16, true);
      padding-top: 0px;
    }
    &__content {
      height: 100%;
      min-height: 100%;
      box-sizing: border-box !important;
      padding-top: 0px;
      padding-bottom: 0px;

      .multiselect__element {
        .multiselect__option {
          white-space: nowrap;
          &--selected {
            font-weight: 400;
          }
        }
      }
    }
    &__option {
      min-height: 32px;
      display: flex;
      align-items: center;
      white-space: nowrap;
      padding: 0;
      span {
        padding: 8px 24px;
      }
    }
  }
}

/deep/ .multiselect__option {
  .noOption {
    width: fit-content;
    white-space: nowrap;
    color: #ADB6BE;
    padding-top: 0px;
    padding-bottom: 0px;
  }
}

.border-active {
  /deep/ .multiselect {
    &--active, &--focus {
      border-color: #8B9BC4;
      outline: 0;
      border-radius: 5px;
      box-shadow: 0 0 0 2px rgba(78, 102, 166, 0.5);
      .multiselect__tags:not(:has(input)) {
        border-color: #7a8cbb !important;
        padding-top: 0;
        padding-bottom: 0;
      }
      .multiselect__tags {
        border-color: #7a8cbb !important;
      }
      .multiselect__option {
        font-weight: normal;
        word-wrap: break-word !important;
        white-space: normal;
        &--selected {
          font-weight: 400;
        }
      }
    }
  }
}

.horizontal-direction {
  /deep/ .multiselect__content-wrapper {
    left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/FormSelectComponent.vue